import { useCallback } from 'react';

import { isSelectionChanged } from '@app/components/Modals/BotDetailsModal/utils/triggerTagsGroups';
import type { MultiSelectValue } from '@app/shared/components/MultiSelect/types';

interface UseTriggerTagsSelectArgs {
  value: MultiSelectValue;
  onChange: (value: MultiSelectValue) => void;
  onSelectionChange?: (value: MultiSelectValue) => void;
}

// Валидируем только при смене тегов/списков: переключение И/ИЛИ/НЕТ
// в ещё пустом списке не должно сразу подсвечивать ошибку.
export const useTriggerTagsSelect = ({
  value,
  onChange,
  onSelectionChange,
}: UseTriggerTagsSelectArgs) => {
  const tagsChangeHandler = useCallback(
    (next: MultiSelectValue) => {
      onChange(next);

      if (isSelectionChanged(value, next)) onSelectionChange?.(next);
    },
    [value, onChange, onSelectionChange]
  );

  return { tagsChangeHandler };
};
